import script from "./aba-button-right.vue?vue&type=script&setup=true&lang=ts"
export * from "./aba-button-right.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__